import { useMemo } from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({ gfm: true, breaks: true });

const SafeMarkdown = ({ children }: { children: string }) => {
  const html = useMemo(() => {
    const raw = marked.parse(children || "", { async: false }) as string;
    return DOMPurify.sanitize(raw);
  }, [children]);
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default SafeMarkdown;